export const subscriptionTranslations = {
  guard: {
    checkingAccess: { ru: "Проверка доступа...", en: "Checking access..." },
    loadingHotelData: { ru: "Загрузка данных отеля", en: "Loading hotel data" },
    takingLonger: { ru: "Загрузка занимает больше времени чем обычно", en: "Loading is taking longer than usual" },
    retry: { ru: "Повторить", en: "Retry" },
    continue: { ru: "Продолжить", en: "Continue" }
  },
  banner: {
    expired: { ru: "Подписка истекла, выберите подписку в разделе подписки", en: "Subscription expired, please select a subscription in the subscriptions section" }
  }
};

export default subscriptionTranslations;